/**
 * Formato de cifras de las calculadoras en inglés: 1,234.50 y €1,234.50.
 * El castellano no pasa por aquí: cada calculadora conserva su formato de
 * siempre (`x.toFixed(2)€`, `toLocaleString("es-ES")`…).
 */

export function numeroEn(n: number, decimales = 2): string {
  if (!Number.isFinite(n)) return "0"
  return n.toLocaleString("en-GB", { minimumFractionDigits: decimales, maximumFractionDigits: decimales })
}

/** -4.5 → «-€4.50»; con 0 decimales, «€1,235». */
export function eurosEn(n: number, decimales = 2): string {
  if (!Number.isFinite(n)) return "€0"
  return `${n < 0 ? "-" : ""}€${numeroEn(Math.abs(n), decimales)}`
}
